/**
 * Central route path definitions.
 *
 * Import from here instead of importing container modules just to
 * access their `.route` static property.  This keeps route strings
 * available for navigation while allowing React.lazy() code-splitting
 * in Routes.jsx.
 */

export const ROUTES = {
  SIGN_IN: "/sign-in",
  PASSWORD_LOST: "/password-lost",
  NEW_PASSWORD: "/new-password/:id",
  ACCEPT_INVITE: "/accept-invitation/:token",
  HOME: "/",
  POSTING_DETAIL: "/postings/:postingId",
  TICKET_LIST: "/tickets",
  TICKET_NEW: "/tickets/new",
  TICKET_DETAIL: "/tickets/:ticketId",
  DOCUMENTS: "/documents",
  PROPERTY_MANAGEMENT: "/property-management",
  PROFILE: "/profile",
  PROFILE_ACCOUNT: "/profile/account",
  PROFILE_PRIVACY: "/profile/privacy",
  PROFILE_TERMS_OF_USE: "/profile/terms",
  PROFILE_MY_DATA: "/profile/my-data",
  PROFILE_DATA_PRIVACY: "/profile/data-privacy",
  PROFILE_IMPRINT: "/profile/imprint",
  PROFILE_CONTACT: "/profile/contact",
  PROFILE_TANDC: "/profile/tandc",
  UPDATE_PASSWORD: "/update-password",
} as const;
